module.exports = __webpack_public_path__ + "img/antes_despues_16.2e1e1a2b.png";